module.exports = __webpack_public_path__ + "static/media/Bronze.d9543713.svg";